export const calculateTotalAmount = ({
  bookingSidebar,
  extraBedPrice,
  totaldays,
}) => {
  return bookingSidebar?.reduce((acc, plan) => {
    const roomPrice =
      plan.type !== "addonservice" ? plan.totalRate * plan.selectedRooms : 0;
    const extraBedCharge = plan.extraBed
      ? Object.values(plan.extraBed || {}).reduce(
          (sum, isExtraBed) =>
            sum + (isExtraBed ? extraBedPrice * totaldays : 0),
          0
        )
      : 0;
    const addOnServicePrice =
      plan.type === "addonservice" ? plan.servicePrice : 0;

    return acc + roomPrice + extraBedCharge + addOnServicePrice;
  }, 0);
};
